<template>
    <button :class="buttonClasses"
            @click.prevent="isDisabled()"
            @mouseleave="onHover()"
            @mouseover="onHover()"
            class="button">
        {{getText}}
        <i :class="getIcon" class="button-icon" v-if="getIcon"></i>
    </button>
</template>

<script>
    export default {
        name: "Button",
        props: {
            color: String,
            text: String,
            icon: String,
            inverted: Boolean,
            disabled: Boolean
        },
        created() {
            // init colorClass if value passed
            if (this.color) {
                this.colorClass = this.color + this.colorPostFix;
            } else {
                this.colorClass = this.defaultColor + this.colorPostFix;
            }

            // invert if needed
            if (this.inverted) {
                this.colorClass = this.colorClass + this.outlinePostFix;
            }
        },
        data() {
            return {
                defaultColor: 'blue',
                colorPostFix: '-button',
                outlinePostFix: '-outline',
                colorClass: ''
            }
        },
        methods: {
            onHover() {
                // switch between outline and filled view
                if (this.colorClass.includes(this.outlinePostFix)) {
                    this.colorClass = this.colorClass.split('-')[0] + this.colorPostFix;
                } else {
                    this.colorClass = this.colorClass + this.outlinePostFix;
                }
            },
            isDisabled() {
                return this.disabled;
            }
        },
        computed: {
            buttonClasses() {
                const disabledClass = this.disabled ? 'disabled' : '';
                return this.colorClass + ' ' + disabledClass;
            },
            getText() {
                return this.text;
            },
            getIcon() {
                return this.icon;
            }
        }
    }
</script>

<style scoped>
    @import '../../../css/shared/button/button.css';
    @import '../../../css/shared/button/button-colors.css';
</style>